// extracted by mini-css-extract-plugin
export default {"profileLabel":"StarterProfileUpdateInfo_profileLabel__gQ4lk","profileDetails":"StarterProfileUpdateInfo_profileDetails__fpmZO","info":"StarterProfileUpdateInfo_info__Rn7gE"};